// extracted by mini-css-extract-plugin
export default {"templateHeader":"Templates_templateHeader__gminl","searchHeader":"Templates_searchHeader__0nJ3Z"};